export default __webpack_public_path__ + "d39e6b2298c4a4f4f82bb816b7fbe04a.svg";